module.exports = __webpack_public_path__ + "static/media/videao-popup.8cdd1924.png";